import { Popover } from 'antd';
import React, { useState } from 'react';
import { ReactComponent as Info } from '../../../../../assets/icons/info.svg';

export const MapLegend = (): JSX.Element => {
  const [isLegendOpen, setIsLegendOpen] = useState(false);

  return (
    <div style={{
      display: 'flex',
      borderRadius: '2px',
      padding: '6px',
      position: 'absolute',
      left: '12px',
      bottom: '140px',
      backgroundColor: isLegendOpen ? '#E1E3E8' : 'white',
      zIndex: 1000,
    }}
    >
      <Popover
        placement="right"
        trigger="click"
        open={isLegendOpen}
        onOpenChange={() => setIsLegendOpen(!isLegendOpen)}
        overlayInnerStyle={{ borderRadius: '8px' }}
        content={(
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            fontSize: '14px',
            borderRadius: '8px',
          }}
          >
            <span style={{ fontWeight: 600 }}>Pin information</span>
            <div style={{
              display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center',
            }}
            >
              <div style={{
                height: '16px', width: '16px', borderRadius: '50%', backgroundColor: '#E13333',
              }}
              />
              <span>
                {'Condition critical'.toUpperCase()}
              </span>

            </div>
            <div style={{
              display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center',
            }}
            >
              <div style={{
                height: '16px', width: '16px', borderRadius: '50%', backgroundColor: '#FD9E0F',
              }}
              />
              <span>{'Major condition/severity'.toUpperCase()}</span>
            </div>
            <div style={{
              display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center',
            }}
            >
              <div style={{
                height: '16px', width: '16px', borderRadius: '50%', backgroundColor: '#001D66',
              }}
              />
              <span>{'Good condition'.toUpperCase()}</span>
            </div>
          </div>
        )}
        getPopupContainer={() => document.getElementById('map') as HTMLElement}
      >
        <Info />

      </Popover>
    </div>

  );
};
